import { useSelector } from 'react-redux';
import { EventsState } from '../../../store/types';
import { PropsWithChildren, useEffect, useState } from 'react';
import { EPermissions } from '../../../types/working-model';
import { userHasRoleOnActiveChannel } from '../../../utils/utils';

interface AuthWrapperProps {
	allowedRoles?: string[]
}

export function AuthWrapper({ allowedRoles = [], children }: PropsWithChildren<AuthWrapperProps>): JSX.Element {
	const {
		user
	} = useSelector((state: EventsState) => state.AuthReducer);

	const [hasPermission, setHasPermission] = useState<boolean>(false);

	useEffect(() => {
		const hasRole = userHasRoleOnActiveChannel([...allowedRoles, EPermissions.Owner, EPermissions.Admin], user);
		setHasPermission(hasRole);
	}, [user, allowedRoles]);

	if (hasPermission) {
		return <>{children}</>;
	}

	return <></>;
}